import Chart from "../../../../src/client/katnh/interactions/chart/Chart.js";
import DvtArm from "../../../../src/client/katnh/diagnostische-strategie-bij-verdenking-diepe-veneuze-trombose-arm.json";
import * as React from 'react';
export default {
  Chart,
  DvtArm,
  React
};